const FormatTelFilter = angular.module("FormatTelFilter", []).filter("formatTel", [
    function () {
        return function (prettyTelephoneString) {
            prettyTelephoneString = prettyTelephoneString || "";
            return prettyTelephoneString.replace(/[^\d\+]*/g, "");
        };
    }
]);

export default FormatTelFilter;
